'use client';

import { MouseEvent, ReactNode } from 'react';
import styles from './css/ButtonSemiTransparent.module.css';

interface IButtonSemiTransparentProps {
  handleClick?: () => void;
  className?: string;
  children: ReactNode;
}

export const ButtonSemiTransparent = ({
  handleClick = () => {},
  className = '',
  children = <></>,
}: IButtonSemiTransparentProps) => (
  <button className={`${styles.btnSemiTransparent} ${className}`} onClick={handleClick}>
    {children}
  </button>
);
